/**
 * @packageDocumentation
 * @module appStructureEnums
 *
 * @remarks
 * This file is used to manage the applications structure and features.
 * We manage the sidebar apps, app features, page tabs, and other nested features here.
 */

/**
 * Top Level Sidebar Apps
 */
export enum EvidencePlatformSidebarAppID {
  projects = 'projects',
  dataAdministration = 'data-administration',
  organizations = 'organizations',
  users = 'users',
  extractionAccuracy = 'extraction-accuracy',
  dataReliability = 'data-reliability',
  conceptGroups = 'concept-groups',
}

/**
 * Project Sidebar App Features
 */
export enum ProjectsSidebarAppFeatureId {
  cohorts = 'cohorts',
  dataReliability = 'data-reliability',
}

export enum CohortsFeaturePage {
  cohortBuilder = 'cohort-builder',
}

export enum CohortBuilderPageTab {
  // Cohort definition tabs
  results = 'results',
  definition = 'definition',
  history = 'history',

  // Research Assistant tabs
  researchAssistant = 'research-assistant',

  // Foundational components tabs
  events = 'events',
  concepts = 'concepts',
  datasets = 'datasets',
}

export enum SubjectsDrillDown {
  subjectsDetail = 'subjects-detail',
}

export enum DataReliabilityPageTab {
  accuracy = 'accuracy',
  completeness = 'completeness',
  traceability = 'traceability',
}

/**
 * Data Administration Sidebar App Features
 */
export enum DataAdministrationSidebarAppFeaturesId {
  dataIntake = 'data-intake',
  datasetDelivery = 'dataset-delivery',
}

/**
 * Organizations Sidebar App Features
 */
export enum OrganizationsSidebarAppFeatureId {
  organizations = 'organizations',
}

/**
 * Organizations Page Tabs
 */
export enum OrganizationsPageTab {
  customers = 'customers',
  researchPartners = 'research-partners',
  verantos = 'verantos',
}

/**
 * User Sidebar App Features
 */
export enum UserSidebarAppFeatureId {}
